import { FormDialog } from 'components/dialog/form'
import { SearchsGuideLineResult, usePostSearchsGuideLine } from 'interface/search/guideLine'
import { useSearchsGuideLineForm, SearchsGuideLineForm } from '../form'

type AddSearchsGuideLineDialogProps = {
  searchId: number
  onSubmit: (result: SearchsGuideLineResult) => void
  onClose: () => void
}
export const AddSearchsGuideLineDialog = ({
  searchId,
  onSubmit,
  onClose
}: AddSearchsGuideLineDialogProps) => {
  const [postState, submit] = usePostSearchsGuideLine(searchId, { onPosted: onSubmit })
  const form = useSearchsGuideLineForm({ searchId, onSubmit: submit })
  return (
    <FormDialog
      open
      fullWidth
      maxWidth="md"
      title="分析対象のガイドラインを登録"
      isLoading={postState.posting}
      error={postState.error}
      body={<SearchsGuideLineForm {...form}/>}
      submitLabel="確定"
      isValid={form.formState.isValid}
      onSubmit={form.submit}
      onClose={onClose}
    />
  )
}
